import { getApiBaseUrl } from './apiBaseUrl';

export const SITE_ASSET_KEYS = [
  'HERO_MAIN_IMAGE',
  'ABOUT_IMAGE',
  'HEADER_LOGO',
  'FOOTER_LOGO',
  'FAVICON',
];


const toAbsoluteUrl = (fileUrl) => {
  if (!fileUrl) {
    return '';
  }

  if (/^https?:\/\//i.test(fileUrl)) {
    return fileUrl;
  }

  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${fileUrl.startsWith('/') ? '' : '/'}${fileUrl}`;
};

export const fetchPublicAssets = async () => {
  const response = await fetch(`${getApiBaseUrl()}/api/public/assets`);

  if (!response.ok) {
    throw new Error(`Failed to fetch public assets: ${response.status}`);
  }

  const assets = await response.json();

  return assets.reduce((accumulator, asset) => {
    accumulator[asset.assetKey] = {
      ...asset,
      resolvedUrl: toAbsoluteUrl(asset.fileUrl),
    };
    return accumulator;
  }, {});
};

export const uploadAdminAsset = async (assetKey, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${getApiBaseUrl()}/api/admin/assets/${assetKey}`, {
    method: 'POST',
    credentials: 'include', //  쿠키가 자동 전송됨 (credentials: 'include' 필요
    body: formData,
  });

  if (!response.ok) {
    const error = new Error(`Failed to upload asset: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  const asset = await response.json();

  return {
    ...asset,
    resolvedUrl: toAbsoluteUrl(asset.fileUrl),
  };
};

